/** Can handle hover highlight via highlightContext */
import {useHighlighterContext} from 'Contexts/HighlighterContext';

export const useHoverHighlight = ({rootId}: {rootId: string}) => {
    const {clearHighlightByType, addNodeHighlightsClearOthers} = useHighlighterContext();

    return {
        onNodeMouseEnter: (e: React.MouseEvent, id?: string) => {
            if (id === rootId) {
                return false;
            }
            addNodeHighlightsClearOthers(id ? [id] : [], 'Hover');
            return true;
        },
        onNodeMouseLeave: (e: React.MouseEvent, id?: string) => {
            clearHighlightByType('Hover');
            return false;
        },
    };
};
